import request from "../utils/request";
//===================大众号入驻页面==========================
// 获取上传七牛
export function getQiniuToken(data, option) {
  return request({
    url: "/background/manage/upload/app/getToken",
    method: "post",
    data: data,
    headers: option,
  });
}
// 获取token有效期 判断token是否过期  /api/client/token/expire
export function tokenExpire(data, option) {
  return request({
    url: "/authorization/api/client/token/expire",
    method: "get",
    params: data,
    headers: option,
  });
}
// 根据token获取用户信息 /account/api/account/user/info?encrypt=
export function getInfo(data, option, ask) {
  return request({
    url: "/account/api/account/user/info?encrypt=" + ask,
    method: "post",
    data: data,
    headers: option,
  });
}
// 发送验证码 /api/client/send/code
export function sendCode(data, option) {
  return request({
    url: "/authorization/api/client/send/code",
    method: "post",
    data: data,
    headers: option,
  });
}
// 短信验证码登录  /api/client/login/sms
export function loginSms(data, option) {
  return request({
    url: "/authorization/api/client/login/sms",
    method: "post",
    data: data,
    headers: option,
  });
}
// /application/listSubChannelClassification  获取大众号列表
// 已修改为 listSubChannelClassification4Regist
export function getTypeList(data, option) {
  return request({
    url: "/subchannel/api/application/listSubChannelClassification4Regist",
    method: "get",
    params: data,
    headers: option,
  });
}
// /common/sysregion/listSysRegionCode  获取地区编码
export function areaList(data) {
  return request({
    url: "/subchannel/common/sysregion/listSysRegionCode",
    method: "get",
    params: data,
  });
}
///api/application/getSubChannelDetailByUser  获取当前大众号的详情
export function getSubChannelDetailByUser(data, option) {
  return request({
    url: "/subchannel/api/application/getSubChannelDetailByUser",
    method: "get",
    params: data,
    headers: option,
  });
}
///api/application/register  用户注册大众号
export function register(data, option) {
  return request({
    url: "/subchannel/api/application/register",
    method: "post",
    data: data,
    headers: option,
  });
}
///api/application/modify  用户修改大众号
export function modify(data, option) {
  return request({
    url: "/subchannel/api/application/modify",
    method: "post",
    data: data,
    headers: option,
  });
}
// /api/application/getSubChannelApplicationStatusByUser 获取用户申请状态
export function getStatusByUser(data, option) {
  return request({
    url: "/subchannel/api/application/getSubChannelApplicationStatusByUser",
    method: "get",
    params: data,
    headers: option,
  });
}
